export default function(options, value) {
  const returnItem = options.slice().filter(item => item.value === value)[ 0 ];
  return returnItem ? returnItem : { label: "-", value: value}
}
